import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import auchanBackground from "@/assets/auchanBackground.jpg";
import logo from "@/assets/logo.svg";
import {toast} from "../ui/use-toast";
import axios from "axios";
import { useCart } from "../Cart/CartContext";

const endpointais = `${process.env.REACT_APP_AIS_ENDPOINT!}`;

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [, setIsAuthenticated] = useState(!!localStorage.getItem("token"));
    const navigate = useNavigate();
    const { fetchCart } = useCart();

    useEffect(() => {
        console.log("Clearing tokens from localStorage on logout");

        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("refreshTokenExpiryTime")

        setTimeout(() => {
            console.log("Token after clearing:", localStorage.getItem("token"));
        }, 500);
    }, []);

    const handleLogin = async () => {
        try {
            const response = await axios.post(`${endpointais.replace("/v1", "")}/token/issue`, {
                    clientId: "",
                    accountName: email,
                    apiKey: "",
                    password: password,
                }
            );

            const data = response.data;
            localStorage.setItem("token", data.token);
            localStorage.setItem("refreshToken", data.refreshToken);
            localStorage.setItem("refreshTokenExpiryTime", data.refreshTokenExpiryTime);

            setIsAuthenticated(true);
            
            await fetchCart();

            navigate("/");

        } catch (error: any) {
            if (error.response?.status === 423) {
                toast({description: "Contul este blocat. Contactati administratorul."});
                return;
            }
            console.error("Eroare la autentificare:", error);
            toast({description: "Autentificare esuata"});
        }
    };

    return (
        <>
            <div>
                <section className="bg-white">
                    <div className="lg:grid lg:min-h-screen lg:grid-cols-12">
                        <section
                            className="relative flex h-32 items-end bg-red-500 lg:col-span-5 lg:h-full xl:col-span-6">
                            <img alt="" src={auchanBackground}
                                 className="absolute inset-0 h-full w-full object-cover opacity-80"/>

                            <div className="hidden lg:relative lg:block lg:p-12">
                                <img src={logo} width="150" height="50" className="text-center" alt="logo"/>

                                <h2 className="mt-6 text-2xl font-bold text-white sm:text-3xl md:text-4xl">
                                    Welcome to Franciza Auchan
                                </h2>

                                <p className="mt-4 leading-relaxed text-white/90">
                                    Platformă de franciză și parteneriat B2B dedicată extinderii rețelei noastre de
                                    supermarketuri și dezvoltării colaborărilor comerciale la nivel național.
                                </p>
                            </div>
                        </section>

                        <main
                            className="flex items-center justify-center px-8 py-8 sm:px-12 lg:col-span-7 lg:px-16 lg:py-12 xl:col-span-6"
                        >
                            <div className="max-w-xl lg:max-w-3xl">
                                <form action="#" className="flex flex-col items-center mx-auto max-w-md space-y-4"
                                      onSubmit={(e) => {
                                          e.preventDefault();
                                          handleLogin();
                                      }}>
                                    <div className="mx-auto max-w-screen-xl items-center px-4 py-16 sm:px-6 lg:px-8">
                                        <div className="max-w-screen-xl mb-5 w-full">
                                            <label htmlFor="email" className="sr-only">Email</label>

                                            <div className="relative">
                                                <input
                                                    type="email"
                                                    className="w-full rounded-lg border-gray-200 p-3 pe-12 text-lg shadow-sm"
                                                    placeholder="Enter email"
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />

                                                <span
                                                    className="absolute inset-y-0 end-0 grid place-content-center px-4">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="w-6 h-6 text-gray-400"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="2"
                                                            d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                                                        />
                                                    </svg>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="max-w-screen-xl mb-5 w-full">
                                            <label htmlFor="password" className="sr-only">Parola</label>

                                            <div className="relative">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className="w-full rounded-lg border-gray-200 p-3 pe-12 text-lg shadow-sm"
                                                    placeholder="Enter password"
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />

                                                <button
                                                    type="button"
                                                    onClick={() => setShowPassword((prev) => !prev)}
                                                    className="absolute inset-y-0 end-0 grid place-content-center px-4 text-gray-400"
                                                >
                                                    {showPassword ? (
                                                        // icon "eye-off"
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="w-6 h-6"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth={2}
                                                                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 
                                                                   0-8.268-2.943-9.542-7a9.965 9.965 0 012.336-4.058M6.18 
                                                                   6.18A9.965 9.965 0 0012 5c4.478 0 8.268 2.943 
                                                                   9.542 7a9.965 9.965 0 01-4.043 5.197M6.18 6.18L18 18"
                                                            />
                                                        </svg>
                                                    ) : (
                                                        // icon "eye"
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="w-6 h-6"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                            />
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M2.458 12C3.732 7.943 7.523 5 
                                                                   12 5c4.478 0 8.268 2.943 9.542 
                                                                   7-1.274 4.057-5.064 7-9.542 
                                                                   7-4.477 0-8.268-2.943-9.542-7z"
                                                            />
                                                        </svg>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        <div className="flex items-center ml-14">
                                            <button
                                                type="submit"
                                                className="inline-block shrink-0 rounded-md border border-red-700 bg-red-600 px-12 py-3 text-sm font-medium text-white transition hover:bg-transparent hover:text-red-600 focus:outline-none focus:ring active:text-blue-500"
                                            >
                                                Intra in cont
                                            </button>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </main>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Login;
